import axios from 'axios';

export const config = {
  baseURL: `${process.env.REACT_APP_API_URL}`,
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
    Accept: 'application/json',
    'Content-Type': 'application/json',
    // Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
  },
  timeout: 60000,
};

const API = axios.create(config);

export default API;
